import axios from "axios";

export const apiPlan = axios.create({
  baseURL: process.env.REACT_APP_PLAN_URL || "http://localhost:8002",
});
